(() => {
  const items = document.querySelectorAll('.amaca-header-nav__item');
  const sectionHeader = document.querySelector('.section-header');

  items.forEach((item) => {
    const open = () => {
      item.classList.add('is-pointer-open');
      sectionHeader?.classList.add('menu-open');
    };

    const close = () => {
      if (item.matches(':focus-within')) return;
      item.classList.remove('is-pointer-open');
      if (![...items].some((candidate) => candidate.classList.contains('is-pointer-open'))) {
        sectionHeader?.classList.remove('menu-open');
      }
    };

    item.addEventListener('pointerenter', open);
    item.addEventListener('pointerleave', close);
    item.addEventListener('focusin', open);
    item.addEventListener('focusout', () => {
      window.setTimeout(() => {
        if (!item.matches(':focus-within')) close();
      }, 0);
    });
  });
})();

(() => {
  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('a[href]');
    if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;

    const destination = new URL(link.href, window.location.href);
    if (destination.origin !== window.location.origin || destination.pathname !== window.location.pathname) return;

    const isHomeLogo = link.matches('.header__heading-link') && !destination.hash;
    if (!isHomeLogo && (!destination.hash || destination.search !== window.location.search)) return;

    let target;
    if (!isHomeLogo) {
      try {
        target = document.getElementById(decodeURIComponent(destination.hash.slice(1)));
      } catch {
        return;
      }
      if (!target) return;
    }

    event.preventDefault();
    const header = document.querySelector('.section-header');
    const headerHeight = header?.offsetHeight || 0;
    let targetTop = isHomeLogo ? 0 : window.scrollY + target.getBoundingClientRect().top;
    const desktopSection = target?.matches('.amaca-homepage .amaca-section') && window.matchMedia('(min-width: 990px)').matches;
    if (desktopSection) {
      // Layout offsets exclude the section's entrance-animation transform.
      targetTop = 0;
      for (let element = target; element; element = element.offsetParent) {
        targetTop += element.offsetTop;
      }
    }
    const hidesOnScrollDown = header?.querySelector('sticky-header')?.getAttribute('data-sticky-type') === 'on-scroll-up';
    const headerClearance = desktopSection && hidesOnScrollDown && targetTop > window.scrollY + headerHeight + 16 ? 0 : headerHeight;
    const top = isHomeLogo ? 0 : Math.max(0, targetTop - headerClearance - 16);
    const nextUrl = isHomeLogo ? window.location.pathname + window.location.search : destination.pathname + destination.search + destination.hash;
    if (nextUrl !== window.location.pathname + window.location.search + window.location.hash) {
      window.history.pushState(null, '', nextUrl);
    }
    window.scrollTo({
      top,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
    });
  });
})();

(() => {
  const menu = document.querySelector('.amaca-localization-menu');
  if (!menu) return;
  const summary = menu.querySelector('.amaca-locale-trigger');
  const wrapper = menu.closest('.header-wrapper');
  const desktop = window.matchMedia('(min-width: 990px)');
  let openedByHover = false;
  const close = () => {
    openedByHover = false;
    menu.classList.remove('is-open');
    menu.querySelector('.amaca-locale-panel').inert = true;
    summary.setAttribute('aria-expanded', 'false');
    if (wrapper) wrapper.preventHide = false;
  };
  const open = () => {
    if (!desktop.matches) return;
    if (!menu.classList.contains('is-open')) openedByHover = true;
    document.querySelectorAll('.amaca-header-nav__item').forEach(item => item.classList.remove('is-pointer-open'));
    menu.classList.add('is-open');
    menu.querySelector('.amaca-locale-panel').inert = false;
    summary.setAttribute('aria-expanded', 'true');
    if (wrapper) wrapper.preventHide = true;
  };
  menu.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') open(); });
  summary.addEventListener('click', event => {
    if (openedByHover && menu.classList.contains('is-open')) {
      event.preventDefault();
      openedByHover = false;
      return;
    }
    if (menu.classList.contains('is-open')) close();
    else { open(); openedByHover = false; }
  });
  // Use the full panel bounds even while its opening animation clips the contents.
  document.addEventListener('pointermove', event => {
    if (event.pointerType !== 'mouse' || !menu.classList.contains('is-open') || menu.matches(':focus-within')) return;
    const headerBounds = wrapper.getBoundingClientRect();
    const panelBounds = menu.querySelector('.amaca-locale-panel').getBoundingClientRect();
    if (event.clientX < headerBounds.left || event.clientX > headerBounds.right ||
        event.clientY < headerBounds.top || event.clientY > panelBounds.bottom) close();
  });
  menu.addEventListener('focusout', () => {
    setTimeout(() => { if (!menu.matches(':focus-within') && !menu.matches(':hover')) close(); }, 0);
  });
  document.addEventListener('pointerdown', event => {
    if (menu.classList.contains('is-open') && !menu.contains(event.target)) close();
  });
  menu.addEventListener('keydown', event => {
    if (event.key === 'Escape') { close(); summary.focus(); }
  });
  document.querySelectorAll('.amaca-header-nav__item').forEach(item => {
    item.addEventListener('pointerenter', close);
    item.addEventListener('focusin', close);
  });
  desktop.addEventListener('change', close);
  close();
})();
